// define an action in Redux is to separately declare an action type
export const userAction = (incomingType, incomingValue) => {
    return {
      type: incomingType,
      payload: incomingValue,
    }
  }
  